export default __webpack_public_path__ + "static/media/theFactorsErika.34d9ff67.wav";